import React from 'react';
import { AutoCompleteField } from './index';

const TableCellAutocomplete = ({
    id,
    value,
    label = '',
    options,
    className,
    disabled = false,
    rowIndex,
    placeholder = 'Select',
    error = '',
    containerClass = {},
    errorClassName = '',
    onChange: onChangeProp,
    menuPlacement,
}) => {
    return (
        <td className={className}>
            <AutoCompleteField
                controlled
                searchable
                label={label}
                value={value}
                disabled={disabled}
                isMulti={false}
                options={options(rowIndex)}
                placeholder={placeholder}
                containerClass={containerClass}
                errorClassName={errorClassName}
                error={error}
                onChange={option => onChangeProp(option.value, id, rowIndex)}
                menuPlacement={menuPlacement}
            />
        </td>
    );
};

TableCellAutocomplete.propTypes = {
    ...AutoCompleteField.propTypes,
};

export default TableCellAutocomplete;
